import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export interface ScrollToTopProps {}

const ScrollToTop: React.FC<ScrollToTopProps> = () => {
  const locationPathName = useLocation().pathname;
  useEffect(() => {
    // Use requestAnimationFrame so the scroll fires after the browser has
    // painted the new page. Without this, calling scrollTo during a mobile
    // keyboard close animation (iOS/Android) can be silently ignored or
    // overridden by the keyboard dismiss, leaving the page at a wrong offset.
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
  }, [locationPathName]);

  return null;
};

export default ScrollToTop;
